import React from "react";

const VerifySeasonalBadges = () => {
  return <div>VerifySeasonalBadges</div>;
};

export default VerifySeasonalBadges;
